/**
 * Card de estatística do app — número grande, rótulo e uma linha de contexto.
 *
 * Nasceu como `IntelStatCard` na Inteligência de Mercado e foi promovido para
 * `ui/` quando a Visão geral de /campaigns precisou do MESMO card (CLAUDE.md
 * §4: dois cards iguais com dois nomes é como a duplicação começa). O nome
 * antigo continua exportado por `marketIntelligence/intelligenceShared.jsx`
 * para os consumidores de lá não mudarem.
 *
 * O card não formata nada: `value` e `sub` chegam prontos de quem sabe o que o
 * número é (dinheiro, contagem, '—' para ausente) — formatação mora em `utils/`.
 */

const STAT_TONES = {
    // value = cor do número; ring = destaque de hover dos cards clicáveis.
    mono: { value: 'text-black dark:text-white' },
    danger: { value: 'text-danger-600 dark:text-danger-400' },
    warning: { value: 'text-warning-600 dark:text-warning-400' },
    success: { value: 'text-success-600 dark:text-success-400' },
    info: { value: 'text-info-600 dark:text-info-400' },
};

/**
 * Com `onClick` vira botão (os cards do Briefing e da Visão geral LEVAM à tela
 * que explica o número — o card é a porta, não só o display); sem `onClick` é
 * um card estático. `title` é o tooltip nativo: o lugar da definição do número
 * quando ela não cabe no rótulo (ex.: "isto não é valor recebido").
 */
export const StatCard = ({ label, value, sub = null, tone = 'mono', icon: Icon = null, onClick = null, title }) => {
    const tones = STAT_TONES[tone] || STAT_TONES.mono;
    const body = (
        <>
            <div className="flex items-center justify-between gap-2">
                <p className="text-sm text-mono-600 dark:text-mono-400">{label}</p>
                {Icon ? <Icon size={22} className="shrink-0 text-mono-400" /> : null}
            </div>
            <p className={`mt-2 text-3xl font-bold tabular-nums ${tones.value}`}>{value}</p>
            {sub ? <p className="mt-1 text-xs text-mono-500">{sub}</p> : null}
        </>
    );
    const baseClass = 'rounded-xl border border-mono-200 bg-white p-5 text-left dark:border-mono-800 dark:bg-mono-950';

    if (typeof onClick !== 'function') {
        return (
            <div className={baseClass} title={title}>
                {body}
            </div>
        );
    }
    return (
        <button
            type="button"
            onClick={onClick}
            title={title}
            className={`${baseClass} w-full transition-colors hover:border-mono-400 dark:hover:border-mono-600`}
        >
            {body}
        </button>
    );
};

export default StatCard;
